<div class="container-fluid pt-3">
	<jhi-collapsible heading="{{translateService.instant('observations.studies.title')}}">
		<div class="container-fluid">
			<div class="table-responsive custom-scroll-style" style="max-height: 400px; overflow-y: auto; overflow-x: auto;">
				<table class="table table-striped table-bordered table-curved" *ngIf="studies.length else nodata">
					<thead class="sticky-header">
					<tr>
						<th scope="col" jhiTranslate="observations.studies.study-name">Study Name</th>
						<th scope="col" jhiTranslate="observations.studies.description">Description</th>
					</tr>
					</thead>
					<tbody>
					<tr *ngFor="let study of studies">
						<td><a *ngIf="germplasmDetailsContext.isModal && isClickable(study)" href="javascript: void(0);" (click)="openStudy(study.studyId)"><truncate-span [textInput]="study.name"></truncate-span></a>
                            <span *ngIf="germplasmDetailsContext.isModal && !isClickable(study)" class="btn btn-link disabled p-0"><truncate-span [textInput]="study.name"></truncate-span></span>
							<span *ngIf="!germplasmDetailsContext.isModal"><truncate-span [textInput]="study.name"></truncate-span></span>
						</td>
						<td><truncate-span [textInput]="study.description"></truncate-span></td>
					</tr>
					</tbody>
				</table>
				<ng-template #nodata>
					<table class="table table-striped table-bordered table-curved">
						<thead>
						<tr>
							<th></th>
						</tr>
						</thead>
						<tbody>
						<tr>
							<td jhiTranslate="no.data"></td>
						</tr>
						</tbody>
					</table>
				</ng-template>
			</div>
		</div>
	</jhi-collapsible>
	<jhi-collapsible heading="{{translateService.instant('observations.observations.title')}}">
		<iframe [src]="graphicalQueryUrl" style="border: 0" width="100%" height="600"></iframe>
	</jhi-collapsible>
</div>
